import request from '@/utils/request'


// 科室查找，获取分页科室列表
export function getDepts(data) {
  return request({
    url: '/api/dept/queryDept',
    method: 'get',
    params: data,
  })
}
